import * as _ from "lodash"
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import { WB_DataMartRow } from "../PA.Core/PAdbSchemaRows";
import {PAdbContext} from "../PA.Core/PAdbContext";
import { esWB_DataMart, esWB_Period } from "../PA.Core/PAdbSchema";

import {PAEnvironment} from "../PA.Core/PAEnvironment";
import { DataMartBO } from "./DataMartBO";

export class DataMartBOValidations {

    static async ValidateFields(aBO: DataMartBO): Promise<void> {
        const self = this;
        let dbContext = new PAdbContext({})

        if (_.isEmpty(aBO.WB_DataMart.cif.DM_ID))
        {
            self.addMessage(aBO, "emptyID", 'Template ID cannot be empty')

        }
        else
            aBO.ValidateMessageProvider.removeMessage("emptyID")
        if (_.isEmpty(aBO.WB_DataMart.cif.DM_NAME))
        {
            self.addMessage(aBO, "emptyName", 'Template Name cannot be empty')

        }
        else
            aBO.ValidateMessageProvider.removeMessage("emptyName")


        // Data Marts are considered duplicates only within the same Master Data Set and Sales Org
        let dataMartRows: WB_DataMartRow[] = await dbContext.findAll(esWB_DataMart,
            {where: {DELETED_IND: {neq: '1'},
                    WB_DATAMART_ID: {neq: aBO.WB_DataMart.cif.WB_DATAMART_ID},
                    WB_MDSET_ID: aBO.WB_DataMart.cif.WB_MDSET_ID,
                    WB_SALESORG_ID: aBO.WB_DataMart.cif.WB_SALESORG_ID,
                    DM_ID: aBO.WB_DataMart.cif.DM_ID}})

        //Duplicate ID/Name combo
        let dataMartRowsIDName: WB_DataMartRow[] = await dbContext.findAll(esWB_DataMart,
            {where: {DELETED_IND: {neq: '1'},
                    WB_DATAMART_ID: {neq: aBO.WB_DataMart.cif.WB_DATAMART_ID},
                    WB_MDSET_ID: aBO.WB_DataMart.cif.WB_MDSET_ID,
                    WB_SALESORG_ID: aBO.WB_DataMart.cif.WB_SALESORG_ID,
                    DM_ID: aBO.WB_DataMart.cif.DM_ID,
                    DM_NAME: aBO.WB_DataMart.cif.DM_NAME,
                }})
        if (!_.isEmpty(dataMartRowsIDName)) {
            self.addMessage(aBO, "duplicateIDName", 'Existing Data Mart(s) with the same ID and Name: ' +
                '\nData Marts: ' + _.map(dataMartRowsIDName, (a) => `${a.cif.DM_NAME} (${a.cif.DM_ID})`).join(",")
            )
            return
        } else {
            aBO.ValidateMessageProvider.removeMessage("duplicateIDName")
        }

        if (!_.isEmpty(dataMartRows)) {
            self.addMessage(aBO, "duplicateID", 'Existing Data Mart(s) with the same ID: ' +
                '\nData Marts: ' + _.map(dataMartRows, (a) => `${a.cif.DM_NAME} (${a.cif.DM_ID})`).join(",")
            )
        } else {
            aBO.ValidateMessageProvider.removeMessage("duplicateID")
        }

        // from year should be less than through year
        if (aBO.WB_DataMart.cif.WB_PERIOD_ID_START > 0 && aBO.WB_DataMart.cif.WB_PERIOD_ID_END > 0 && aBO.WB_DataMart.cif.PLAN_SCOPE_MANUAL_IND != '1') {
            let startYear = await dbContext.find(esWB_Period, aBO.WB_DataMart.cif.WB_PERIOD_ID_START)
            let endYear = await dbContext.find(esWB_Period, aBO.WB_DataMart.cif.WB_PERIOD_ID_END)

            if (startYear.cif.PERIOD_NAME > endYear.cif.PERIOD_NAME)
                self.addMessage(aBO, "yearError", 'From Year cannot be greater than Through Year')
            else {
                aBO.ValidateMessageProvider.removeMessage("yearError")
            }
        }
    }

    private static addMessage(aBO: DataMartBO, code: string, message: string): void {
        aBO.ValidateMessageProvider.addMessage(
            {
                code: code,
                type: MessageType.Error,
                title: message,
                description: "",
                subtitle: "",
                count: 0
            });
    }
}